<div class="container">
  <div class="row" style="justify-content: space-between; max-width: 95%">
    <div class="col-md-1"><button mat-flat-button (click)="closePanel()" matTooltip="Close panel"><i class="material-icons" style="color: gray; opacity: 60%">{{data?.isSmallerScreen ? 'arrow_downward' : 'arrow_forward'}}</i></button></div>
    @if (site!==null && !hasError) {
      <div class="col-md-1"><button mat-flat-button (click)="openInSharepoint()" matTooltip="Open folder in Sharepoint"><i class="material-icons" style="color: gray; opacity: 60%">open_in_new</i></button></div>
    }
    <div>
      <div class="breadcrumb">
        @for (folder of folders; track folder; let last = $last) {
          <a href="" class="nav-button" (click)="$event.preventDefault(); breadcrumbNavigation(folder)" style="font-size: 12px;margin-top: 8px; margin-bottom: 8px">
            {{folder}}
          </a>
          @if (!last) {
            <i class="material-icons" style="font-size: 20px; margin-right: 3px; margin-left: 3px">chevron_right</i>
          }
        }
      </div>
      <div class="row" style="justify-content: space-between">
        @if (!hasError) {
          <div class="col-md-3"><mat-checkbox (change)="selectAll($event)"><span style="white-space: nowrap">Select All</span></mat-checkbox></div>
        }
      </div>
      @if (!hasError && spFiles.length > 0 && !isLoading) {
        @for (file of spFiles; track file) {
          <div>
            <div class="file-row">
              @if (file.hasOwnProperty('folder')) {
                <button mat-flat-button class="nav-button" (click)="navigateFolder(file.name)"><i class="material-icons-outlined" style="font-size: 16px; margin-right: 5px" >folder</i>
                {{file.name}}
              </button>
            }
            @if (file.hasOwnProperty('file')) {
              <div>
                <span>
                  <mat-checkbox (change)="selectFile($event.checked, file)" [checked]="isSelected(file)"></mat-checkbox>
                  <i class="material-icons-outlined" style="font-size: 16px; margin-right: 5px">insert_drive_file</i>
                  <a href="{{file.webUrl}}" target="_blank" class="file-hyperlink" [matTooltip]="getFileDetails(file)" matTooltipClass="display-tooltip">{{file.name}}</a>
                </span>
              </div>
            }
          </div>
        </div>
      }
    }
    @if (!notifyRefresh && !hasError && spFiles.length==0 && !isLoading) {
      <div class="col" style="display: flex; flex-direction: column; margin-top: 50%">
        <div class="row" style="justify-content: center">
          <i class="material-icons-outlined" style="max-width: 36px; font-size: 36px; color: gray; opacity: 80%">folder_off</i>
        </div>
        <div class="row" style="justify-content: center; color: gray; opacity: 80%">
          Folder Empty
        </div>
      </div>
    }
    @if (hasError) {
      <div class="col" style="display: flex; flex-direction: column; margin-top: 50%">
        <div class="row" style="justify-content: center; align-items: center">
          <i class="material-icons-outlined" style="max-width: 60px; font-size: 36px; color: gray; opacity: 80%">warning_amber</i>
        </div>
        <div class="row" style="justify-content: center; color: gray; opacity: 80%">
          Please contact help desk for support
        </div>
      </div>
    }
    @if (notifyRefresh) {
      <div class="col" style="height: 400px; align-items: center">
        <div class="row" style="justify-content: center">
          <button mat-flat-button (click)="sharepointService.initializeSiteData(this.site)" style="max-width: 25%; font-size: 16px; color: gray; background-color: whitesmoke">
            <span>
              <i class="material-icons" style="font-size: 16px">refresh</i>
              Refresh
            </span>
          </button>
        </div>
        <div class="row" style="justify-content: center; font-size: 12px; color: gray; opacity: 80%">
          Access to Sharepoint site is currently unauthorized. Click to refresh this pane
        </div>
      </div>
    }
  </div>

